/**
 * Import blocks as components.
 * variations to styling required for gutenberg native blocks
 *  @author Tony Blacker, NHS Leadership Academy
 *  @version 1.1 19th August 2019
 */

import "./00-dashboard";
import "./01-dodont";
import "./02-button";
import "./03-reveal";
import "./04-panel";
import "./06-promo";
import "./07-testimonial";
import "./08-card";
import "./09-row-group";
import "./10-hero-block";

import "./14-filters";